import React from "react";
import { format } from "date-fns";
import "../../App.css";
import "./EvidenceComponents.css";
import { IEvidenceDateHeader } from "@interfaces/Components";

const EvidenceDateHeader: React.FC<IEvidenceDateHeader> = (props) => {
  return <div className="evidenceDateHeader leading-default">{format(props.date, "MMMM yyyy")}</div>;
};

export default EvidenceDateHeader;
